import {createContext, useState} from "react";


interface DashboardPageContextValue {
    driverId: string | null;
}

export const DashboardPageContext = createContext<DashboardPageContextValue>({driverId: null});
export const DashboardPageContextProvider = ({children, driverId}: {
    children: React.ReactNode;
    driverId: string | null;
}) => {
    const [driverIdState, setDriverIdState] = useState(driverId)


    return <DashboardPageContext.Provider value={{driverId}}>{children}</DashboardPageContext.Provider>

}

